import { zAddressDataSchema } from "../zAddressInfo";
import { zRoutePointCommonSchema } from "./routePoint.common";
export const zRoutePointSchemaDom = zRoutePointCommonSchema.extend({
    addressInfo: zAddressDataSchema,
});
export const zRoutePointSchemaCreateDom = zRoutePointSchemaDom.omit({ id: true });
